import React from 'react';
import { useModal } from 'core/modules/Modal/ModalProvider';

function SearchIcon() {
  const { openModal } = useModal();

  const handleClick = () => {
    openModal({ name: 'mt_search' });
  };

  return (
    <button
      className="mn_searchIcon"
      aria-label="Toggle tray navigation"
      aria-controls="mn_quickLinksTrayContent"
      onClick={handleClick}
    />
  );
}

export default SearchIcon;
